import { resolveRoute } from '@/core/routing/resolve-route';
import { RouteResolver } from '@/core/types/route-resolver';
import { store } from '@/store';
import { getModule } from 'vuex-module-decorators';
import CoreStore from '@/core/store';

const coreStore = getModule(CoreStore, store);

export const moduleRootRouteResolver = (...resolvers: RouteResolver[]) => resolveRoute({
	pre: () => {
		coreStore.setIsPageLoaderShown(true);
		coreStore.setIsPageErrorShown(false);
	},
	post: () => {
		window.scrollTo(0, 0);
	},
	errorHandler: (error: Error) => {
		coreStore.setIsPageLoaderShown(false);
		coreStore.setIsPageErrorShown(true);
		console.error(error);
	},
	resolvers: [...resolvers],
});
